export default __webpack_public_path__ + "images/feb18c90cebe08046b5a42b3ba603307-cycling.webp";